module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


if (!bannerPath) var bannerPath='';
if (!cn_title) var title = '';
if (!en_title) var desc = '';
;
__p += '\r\n<section class="ny-banner container">\r\n  <div class="bg-img bg-cover" style="background-image: url(' +
((__t = ( bannerPath )) == null ? '' : __t) +
');"></div>\r\n  <div class="banner-t">\r\n    <h1 class="let_spc"><span class="wow slideInUpBig" data-wow-duration="1.2s">' +
((__t = ( cn_title )) == null ? '' : __t) +
'</span></h1>\r\n    <h2 class="font-en uppercase"><span class="wow slideInUpBig" data-wow-duration="1.5s" data-wow-delay=".6s">' +
((__t = ( en_title )) == null ? '' : __t) +
'</span></h2>\r\n  </div>\r\n</section>';

}
return __p
}